import { z } from 'zod';
import { ROLES } from '@/types/user';
import { SiteSchema } from '@/api/schema/site';

export const UserSnapshotSchema = z.object({
  id: z.string().uuid(),
  givenName: z.string(),
  familyName: z.string(),
  email: z.string().email(),
  role: z.object({
    code: z.nativeEnum(ROLES),
    name: z.string().optional(),
  }),
});

export const UserSchema = z.object({
  id: z.string().uuid(),
  givenName: z.string(),
  familyName: z.string(),
  email: z.string().email(),
  role: z.object({
    code: z.nativeEnum(ROLES),
    name: z.string().optional(),
  }),
  isActive: z.boolean(),
  site: SiteSchema,
});

export type UserSnapshot = z.infer<typeof UserSnapshotSchema>;
export type User = z.infer<typeof UserSchema>;
